import { isMobileTabPathActive } from "./is-mobile-tab-path-active.js";

/**
 * @param {string} pathname
 * @param {import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem[]} tabs
 * @returns {import("../constants/mobile-tabbar-tabs-config.js").MobileTabItem|undefined}
 */
export function getActiveMobileTab(pathname, tabs) {
  const items = Array.isArray(tabs) ? tabs : [];
  return items.find((tab) => isMobileTabPathActive(pathname, tab)) ?? items[0];
}
